// client/src/api/productos.js
import { API_BASE } from '../utils/helpers';

const API_URL = `${API_BASE}/api/productos`;
// const API_URL = 'http://localhost:4000/api/productos'; // Local

const actorHeaders = (actor) => {
  const headers = { 'Content-Type': 'application/json' };
  if (actor?.id) headers['X-User-Id'] = String(actor.id);
  if (actor?.role) headers['X-User-Role'] = String(actor.role);
  return headers;
};

const actorQuery = (actor) => {
  const params = new URLSearchParams();
  if (actor?.id) params.set('actorId', actor.id);
  if (actor?.role) params.set('actorRole', actor.role);
  const query = params.toString();
  return query ? `?${query}` : '';
};

const friendlyMessage = (message) => {
  const raw = String(message || '');
  if (/REFERENCE constraint|FOREIGN KEY|DELETE statement conflicted/i.test(raw)) {
    return 'No se puede eliminar porque tiene reservas asociadas';
  }
  if (/duplicate key|unique|UNIQUE KEY|Violation/i.test(raw)) {
    return 'Ya existe un registro con esos datos';
  }
  if (/String or binary data|truncated/i.test(raw)) {
    return 'Uno de los campos es demasiado largo';
  }
  if (/<!DOCTYPE html>|<html/i.test(raw)) {
    return 'El backend no tiene disponible esta ruta. Revisa que este actualizado.';
  }
  return raw || 'No se pudo completar la solicitud';
};

async function handle(res) {
  const text = await res.text().catch(() => '');
  let data = null;
  try {
    data = text ? JSON.parse(text) : null;
  } catch {}

  if (!res.ok) {
    throw new Error(friendlyMessage(data?.error || data?.message || text || `Error HTTP ${res.status}`));
  }
  return data || { success: true };
}

export async function obtenerProductos(actor = null) {
  const query = actorQuery(actor);
  const separator = query ? '&' : '?';
  const res = await fetch(`${API_URL}${query}${separator}_=${Date.now()}`, {
    headers: actorHeaders(actor),
    cache: 'no-store'
  });
  return handle(res);
}

export async function agregarProducto(producto, actor = null) {
  const res = await fetch(API_URL, {
    method: 'POST',
    headers: actorHeaders(actor),
    body: JSON.stringify(producto),
  });
  return handle(res);
}

export async function editarProducto(id, producto, actor = null) {
  const res = await fetch(`${API_URL}/${id}`, {
    method: 'PUT',
    headers: actorHeaders(actor),
    body: JSON.stringify(producto),
  });
  return handle(res);
}

export async function cambiarDisponibilidadProducto(id, disponible, actor = null) {
  const res = await fetch(`${API_URL}/${id}/disponible`, {
    method: 'PATCH',
    headers: actorHeaders(actor),
    body: JSON.stringify({ Disponible: disponible }),
  });
  return handle(res);
}

export async function eliminarProducto(productId, actor = null) {
  const res = await fetch(`${API_URL}/${productId}${actorQuery(actor)}`, {
    method: 'DELETE',
    headers: actorHeaders(actor),
  });
  return handle(res);
}
